module.exports = __webpack_public_path__ + "img/Toptan.f76dcaf2.png";